/**
 * Ensures that whatever condition is being checked must be true for the
 * remainder of the containing scope otherwise it would throw an error).
 *
 * @param condition - The condition that must be true.
 * @param msg - Optional message
 */
export function assert(condition, msg) {
    if (!condition) {
        throw new Error(`Assertion failed: ${msg}`);
    }
}
//# sourceMappingURL=assert.js.map